import React from "react";

interface SummaryIconProps {
  color?: string;
  width?: number;
  height?: number;
}

const SummaryIcon = (props: SummaryIconProps) => {
  const { color } = props;
  return (
    <div style={{ display: "flex" }}>
      <svg
        width={props.width ? props.width : "17"}
        height={props.height ? props.height : "17"}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_324_7347)">
          <path
            d="M8.66998 16.5C6.53299 16.5 4.524 15.668 3.01299 14.157C1.50198 12.646 0.669983 10.637 0.669983 8.5C0.669983 6.96827 1.10427 5.4795 1.92591 4.19493C2.7256 2.94449 3.85292 1.94244 5.18594 1.29634L5.5288 1.13025L5.86099 1.81596L5.51813 1.98206C4.31189 2.56659 3.29154 3.47356 2.56773 4.60545C1.82473 5.7672 1.43189 7.11394 1.43189 8.5C1.43189 10.4334 2.18465 12.251 3.55181 13.6182C4.91897 14.9853 6.73657 15.7381 8.66998 15.7381C10.6034 15.7381 12.421 14.9853 13.7882 13.6182C15.1553 12.251 15.9081 10.4334 15.9081 8.5C15.9081 6.56659 15.1553 4.74899 13.7882 3.38183C12.5112 2.10488 10.8411 1.364 9.05093 1.27166V7.35531H8.28903V0.5H8.66998C10.807 0.5 12.816 1.332 14.327 2.84301C15.838 4.35402 16.67 6.36301 16.67 8.5C16.67 10.637 15.838 12.646 14.327 14.1567C12.816 15.668 10.807 16.5 8.66998 16.5Z"
            fill={color ?? "white"}
          />
          <path
            d="M8.70599 11.6488L4.1949 7.13745H13.2177L8.70599 11.6488ZM6.03414 7.89936L8.70599 10.5712L11.3781 7.89936H6.03414Z"
            fill={color ?? "white"}
          />
        </g>
        <defs>
          <clipPath id="clip0_324_7347">
            <rect
              width="16"
              height="16"
              fill={color ?? "white"}
              transform="translate(0.669983 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default SummaryIcon;
